import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=5b59ee41&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionComponent.vue?vue&type=script&lang=ts"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=5b59ee41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59ee41",
  null
  
)

export default component.exports